// extracted by mini-css-extract-plugin
module.exports = {"container":"eG","video":"eH","content":"eI","contentContainer":"eJ","title":"eK","text":"eL","button":"eM"};